import { render } from "./ChildrenPaymentView.vue?vue&type=template&id=8c358a0e&ts=true"
import script from "./ChildrenPaymentView.vue?vue&type=script&lang=ts"
export * from "./ChildrenPaymentView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__